// extracted by mini-css-extract-plugin
module.exports = {"component":"campaign_component__mTs7N themeNeutral"};